import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import {quickAddProduct} from '../features/quick-add';
import {swatchGridSection} from '../features/swatch';

const selectors = {
  slider: '[data-slider]',
  slide: '[data-slide]',
  thumb: '[data-slider-thumb]',
};

const classes = {
  isSelected: 'is-selected',
};

const sections = {};

class Look {
  constructor(section) {
    this.container = section.container;
    this.slider = this.container.querySelector(selectors.slider);
    this.slides = this.container.querySelectorAll(selectors.slide);
    this.thumbs = this.container.querySelectorAll(selectors.thumb);

    if (this.slider && this.slides.length && this.thumbs.length) {
      this.resizeEvent = () => this.checkPosition();

      this.slider.addEventListener('scroll', this.resizeEvent);
      document.addEventListener('theme:resize', this.resizeEvent);

      this.thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => {
          const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          if (windowWidth < theme.sizes.small) {
            const parentPadding = parseInt(window.getComputedStyle(this.slider).paddingLeft);
            const thumbLeft = this.slides[i].offsetLeft;
            this.slider.scrollTo({
              top: 0,
              left: thumbLeft - parentPadding,
              behavior: 'smooth',
            });
          }
        });
      });
    }
  }

  checkPosition() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (windowWidth < theme.sizes.small) {
      const sliderWidth = this.slider.offsetWidth;
      const sliderPositionLeft = this.slider.scrollLeft;
      const sliderPositionRight = sliderPositionLeft + sliderWidth;

      this.slides.forEach((slide, i) => {
        const slideWidth = slide.offsetWidth;
        const slidePositionLeft = slide.offsetLeft;
        const slidePositionRight = slidePositionLeft + slideWidth;
        let nextSlideCheck = false;
        const nextSlide = this.slides[i + 1];

        if (nextSlide) {
          const nextSlidePositionWidth = nextSlide.offsetWidth;
          const nextSlidePositionLeft = nextSlide.offsetLeft;
          const nextSlidePositionRight = nextSlidePositionLeft + nextSlidePositionWidth;

          if (sliderPositionRight >= nextSlidePositionRight) {
            nextSlideCheck = true;
          }
        }

        this.thumbs[i].classList.toggle(classes.isSelected, sliderPositionRight >= slidePositionRight && !nextSlideCheck);
      });
    }
  }

  onUnload() {
    if (this.slider && this.slides.length && this.thumbs.length) {
      document.removeEventListener('theme:resize', this.resizeEvent);
      this.slider.removeEventListener('scroll', this.resizeEvent);
    }
  }
}

const lookSection = {
  onLoad() {
    sections[this.id] = new Look(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
};

register('look', [lookSection, slider, quickAddProduct, swatchGridSection]);
